var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 1.79086 2.29086 0 4.5 0H28.5C30.7091 0 32.5 1.79086 32.5 4V28C32.5 30.2091 30.7091 32 28.5 32H4.5C2.29086 32 0.5 30.2091 0.5 28V4Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6723 8.79354C25.0758 9.2074 25.0758 9.87595 24.6723 10.2898L22.7789 12.2318L18.8989 8.25234L20.7923 6.31038C20.9856 6.11167 21.2481 6 21.5217 6C21.7954 6 22.0579 6.11167 22.2512 6.31038L24.6723 8.79354ZM6.349 24.5733V21.3473C6.349 21.1987 6.40073 21.0714 6.5042 20.9653L17.7922 9.38779L21.6722 13.3672L10.3738 24.9447C10.2807 25.0508 10.1462 25.1039 10.0117 25.1039H6.86632C6.57662 25.1039 6.349 24.8704 6.349 24.5733Z",
    fill: "#555893"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.3616,
    y: 23.6362,
    width: 13.1384,
    height: 1.31384,
    rx: 0.656921,
    fill: "#555893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.5ffb82b7.svg";
export { ForwardRef as ReactComponent };